module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-details"
  }, [_c('ui-headline', [_vm._v(_vm._s(_vm.order.headline))]), _vm._v(" "), _c('section', {
    staticClass: "order-details--top"
  }, [_c('section', {
    staticClass: "order-details--img"
  }), _vm._v(" "), _c('section', {
    staticClass: "order-details--info"
  }, [_c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Order: ")]), _vm._v(" "), _c('section', {}, [_vm._v(_vm._s(_vm.order.name))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Created: ")]), _vm._v(" "), _c('section', {}, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Sent: ")]), _vm._v(" "), _c('section', {}, [_vm._v(" " + _vm._s(_vm.order.sent))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attributesection"
  }, [_c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("User: ")]), _vm._v(" "), _c('section', {}, [_vm._v(_vm._s(_vm.order.user))])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attribute"
  }, [_c('span', [_vm._v("Vendor:")]), _vm._v(" "), _c('select', [_c('option', {
    attrs: {
      "value": "choice"
    }
  }, [_vm._v(_vm._s(_vm.order.vendor) + " - $00.00")])])]), _vm._v(" "), _c('section', {
    staticClass: "order-details--attribute"
  }, [_vm._v("Fund Distribution:")]), _vm._v(" "), _c('section', {
    staticClass: "order-details--scrollbox"
  }, [_c('ui-checklist', {
    attrs: {
      "items": ['Medical', 'History', 'Arts', 'Engineering']
    }
  })], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', {
    staticClass: "order-details--totalpricesection"
  }, [_c('section', {
    staticClass: "order-details--totalprice"
  }, [_vm._v(_vm._s(_vm.order.price))]), _vm._v(" "), _c('section', {
    staticClass: "order-details--label"
  }, [_vm._v("Total price")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', {
    staticClass: "order-details--buttons"
  }, [_c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Send"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Reorder"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Cancel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Edit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "order-details--buttons__item"
  }, [_c('ui-button', {
    attrs: {
      "title": "Delete"
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-details--checkedboxes"
  }, [_c('section', {
    staticClass: "order-details--checkedbox__percentage"
  }, [_vm._v("Medical %")]), _vm._v(" "), _c('section', {
    staticClass: "order-details--checkedbox__percentage"
  }, [_vm._v("Engineering %")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc7c6c56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/OrderDetails.vue
// module id = 467
// module chunks = 1